import React, {Component} from 'react';
import PropTypes from "prop-types";

export class QuestionerNavigation extends Component {
    static get propTypes() {
        return {
            questioner: PropTypes.object,
            onNavigation: PropTypes.func,
        }
    }

    constructor(props) {
        super(props);

        this.handleNavigation = this.handleNavigation.bind(this);
    }

    componentDidMount() {
        const {questioner, onNavigation} = this.props;

        questioner.setCurrent(questioner.first);
        onNavigation(questioner.current);
    }

    handleNavigation(direction) {
        const {questioner, onNavigation} = this.props;
        const left = direction === 'left';
        const right = direction === 'right';

        if (left && !questioner.isFirst) {
            questioner.prev();
        }

        if (right && !questioner.isLast) {
            questioner.next();
        }

        onNavigation(questioner.current);
    }

    render() {
        const {questioner} = this.props;
        const {current} = questioner;
        const numberOfQuestions = questioner.length;
        const currentIndex = current ? questioner.index(current)+1 : '';

        return current ? (
            <div className="navigation-wrapper">
                <button type="button" onClick={() => this.handleNavigation('left')}>
                    <i className="fas fa-chevron-left"/>
                </button>
                <span className="counter-text">{`${currentIndex} / ${numberOfQuestions}`}</span>
                <button type="button" onClick={() => this.handleNavigation('right')}>
                    <i className="fas fa-chevron-right"/>
                </button>
            </div>
        ) : (
            <div className="sk-circle"/>
        )
    }
}